import "regenerator-runtime/runtime";
import classNames from "classnames";
import { ReactNode } from "react";
import { useHotkeys } from "react-hotkeys-hook";

import { DialogEnum } from "./Dialog";

type DialogButtonProps = {
  currentDialog: DialogEnum | null;
  wantedDialog: DialogEnum;
  setDialog: Function;
  children: ReactNode;
  hotkey?: string;
  className?: string;
  title: string;
};

const DialogButton = ({
  currentDialog,
  wantedDialog,
  setDialog,
  children,
  hotkey,
  className,
  title,
}: DialogButtonProps) => {
  const toggleDialog = () => {
    if (currentDialog === wantedDialog) {
      setDialog(null);
    } else {
      setDialog(wantedDialog);
    }
  };

  if (hotkey)
    useHotkeys(
      hotkey,
      (e) => {
        if (
          (e.code === "KeyD" && wantedDialog === DialogEnum.InputDiagnosis) ||
          (e.code === "KeyO" && wantedDialog === DialogEnum.StainOrdering)
        )
          e.preventDefault();
        toggleDialog();
      },
      { scopes: ["viewerHotkeys"] },
      [currentDialog, wantedDialog, setDialog]
    );

  useHotkeys(
    "Escape",
    () => {
      setDialog(null);
    },
    [setDialog]
  );

  return (
    <button
      onClick={toggleDialog}
      className={classNames(className, {
        active: currentDialog === wantedDialog,
      })}
      title={title}
    >
      {children}
    </button>
  );
};

export default DialogButton;
